/* eslint-disable import/no-anonymous-default-export */

import produce from 'immer';

// The lists are static reference data, so they are only ever replaced whole.
const toLookup = pairs => ({
  list: pairs,
  byCode: pairs.reduce((map, { code, label }) => {
    map[code] = label;
    return map;
  }, {}),
});

export default (state, { payload, type }) => {
  switch (type) {
    case 'GET_LOOKUPS':
      return produce(state, draft => {
        draft.lookups.voedertypes = toLookup(payload.voedertypes);
        draft.lookups.genetica = toLookup(payload.genetica);
        draft.lookups.castratie = toLookup(payload.castratie);
        draft.lookups.error = null;
        draft.lookups.fetching = false;
      });
    case 'LOOKUPS_ERROR':
      return produce(state, draft => {
        draft.lookups.error = payload;
        draft.lookups.fetching = false;
      });
    case 'CLEAR_STATE':
      return produce(state, draft => {
        draft.lookups.voedertypes = { list: [], byCode: {} };
        draft.lookups.genetica = { list: [], byCode: {} };
        draft.lookups.castratie = { list: [], byCode: {} };
        draft.lookups.error = null;
        draft.lookups.fetching = true;
      });
    default:
      return state;
  }
};
